import { render, staticRenderFns } from "./SyncServers.vue?vue&type=template&id=5704170f&scoped=true"
import script from "./SyncServers.vue?vue&type=script&lang=js"
export * from "./SyncServers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704170f",
  null
  
)

export default component.exports